import {
  Button,
  Grid,
  LinearProgress,
  Menu,
  MenuItem,
  TableCell,
  TableRow, Box
} from "@material-ui/core";
import { IUser } from "src/services";
import {
  // ICoach,
  // IDirectorParams,
  IEvaluationRequest,
  // ISurveyCountResponse,
  ISurveyResponse,
} from "src/services";
import { withStyles } from "@material-ui/core/styles";
import CheckCircle from "@material-ui/icons/CheckCircle";
import * as format from "date-fns/format";
import * as React from "react";
import { Link } from "react-router-dom";
import Component from "src/components/Component";
import withAxios from "src/components/withAxios";
import { EVALUATION_CATEGORIES } from "../survey-link/constants";
import { SurveyLink } from "../survey-link/SurveyLink";
import { ISurvey, TemplateType } from "src/services";
import {
  EDIT_COACH_BUTTON_LABEL,
  PRINT_BUTTON_LABEL,
  VIEW_BUTTON_LABEL,
} from "./constants";
import { styles } from "./styles";
import { IProps, ISportTableState } from "./types";

export default withStyles(styles, { withTheme: true })(
  withAxios(
    class CoachRow extends Component<IProps, ISportTableState> {
      public readonly state = this.buildState({
        endEvaluationSubmitting: false,
        startEvaluationModalVisible: false,
        startEvaluationSubmitting: false,
        headCoachSportid: []
      });
       public componentDidMount = async () => {         
                  const assignSport: any = await this.buildGet<IUser>(this, `/school/directorlistADVaildname/${this.props.school.id}`)()
                                  //  console.log("res=========assignSport", assignSport)

         const arr: any[] = [];

         assignSport?.filter((item1: any) => item1?.isad === false).map((item: any) => {
           arr.push(item?.firstName + " " + item?.lastName
           )
         })
         this.setState({ headCoachSportid: arr })
        //  console.log("statehhhhdd", this.state.headCoachSportid)
       }
      public render() {
        const {
          school,
          coach,
          showPrintButton,
          sport,
          surveys,
          menuAnchor,
          classes,
          oldSport,
          count,
          // coaches,
          submittedSurvey,
          midSeasonCheckin
        } = this.props;
        const {
          startEvaluationSubmitting,
          endEvaluationSubmitting,
          // cancelEvaluationSubmitting,
          // continueEvaluationSubmitting,
        } = this.state;

        const survey = surveys[0];
        // console.log("surveys", surveys, coach)
        const uniqueId = `${sport.id}${coach.id}`;
        // Create the setMenu anchor function for our menu
        const pastSportSurveys = surveys.filter(
          (s) =>
            s.responseCollectionEndDate !== null &&
            s.coachIds.find((cI) => cI === coach.id)
        );
        const latestdata= surveys?.filter((s) => s.coachId === coach.id)
        const printEvaluation = () =>
          this.props.handlePrintPress(coach, sport, survey);
        // const className = coach.active
        //   ? classes.activatedCoach
        //   : classes.deactivatedCoach;

                let className = classes.activatedCoach;
        if (!coach.active) {
          className = classes.deactivatedCoach;
        }

  
        return (
          <TableRow key={uniqueId} className={className}>
            {this.renderPreviousEvaluationsMenu(
              uniqueId,
              pastSportSurveys,
              survey
            )}
            <TableCell>
              <Button onClick={this.openEditCoach} color="primary">
                {EDIT_COACH_BUTTON_LABEL}
              </Button>
            </TableCell>
            {/* {console.log("this.state.headCoachSportid", this.state.headCoachSportid,coach.name,
              this.state.headCoachSportid.some(
                (name: any) => name.toLowerCase() === coach?.name?.toLowerCase()
              )
            )} */}
                        <TableCell className={coach.isDeleted ? classes.deletedCoach : undefined}>{coach.name}
     {midSeasonCheckin && <>
              {
                coach?.user?.email
                  ? ""
                  : this.state.headCoachSportid.some(
                    (name: any) => name.trim().toLowerCase() === coach?.name?.trim().toLowerCase()
                  )
                  
                    ? ""
                    : ""
              }

            </> }</TableCell>
            {midSeasonCheckin &&
            <TableCell>
            {surveys
    .filter((s) => s.coachId === coach.id) // Ensure correct mapping
    .map((survey) => (
      <>
      {survey.responseCollectionEndDate === null &&
      <Box key={survey.id} display="flex" flexDirection="column" gridGap="0.5rem">
       <SurveyLink
                    category={EVALUATION_CATEGORIES.STUDENT}
                    code={survey?.studentCode}
                    clickDisable={false}
                    isStarterPlan={false}
                    route={""}
                  />
                  {survey.type === TemplateType.gritLeadership && (
                    <SurveyLink
                      category={EVALUATION_CATEGORIES.COACH}
                      code={survey?.coachCode}
                      clickDisable={false}
                      isStarterPlan={false}
                      route={""}
                    />
                  )}
                   {survey.enableParentQuestions && (
                    <SurveyLink
                      category={EVALUATION_CATEGORIES.PARENT}
                      code={survey?.parentCode}
                      clickDisable={this.parentOptionValid()}
                      isStarterPlan={false}
                      route={`/${this.props.school.slug}/upgrade-subscription`}
                    />
                  )}
      </Box>
      }
      </>
    ))}

            </TableCell>
      }
            <TableCell>
              {pastSportSurveys.length < 1 ? null : (
                <div className="evaluationHistory">
                  <Button
                    variant="outlined"
                    onClick={this.setMenuAnchor}
                    aria-owns={menuAnchor ? uniqueId : undefined}
                    aria-haspopup="true"
                  >
                  Survey History
                  </Button>
                </div>

              )}
            </TableCell>
            <TableCell>
{this.renderResponseCount()}
            </TableCell>
            <TableCell>
              {midSeasonCheckin === false ?
               <Grid container={true} justifyContent="flex-end">
               {(() => {
                 if (
                   count === undefined ||
                   oldSport !== undefined ||
                   !coach.active
                 ) {
                   return null;
                 }
                 if (
                   count.studentCount +
                   count.coachCount +
                   count.parentCount ===
                   0
                 ) {
                   return (
                     <span className={classes.noResponses}>No responses</span>
                   );
                 }
                 if (
                   survey !== undefined 
                   // &&
                   // this.props.showEvaluations(survey)
                 ) {
                   // Check if we have summaries for this coach, thats means we show stage 4 buttons
                   return (
                     <Grid
                       container={true}
                       spacing={2}
                       justifyContent="flex-end"
                     >
                       {(() => {
                         if (submittedSurvey) {
                           return (
                             <CheckCircle className={classes.completedCheck} />
                           );
                         }
                         return [
                           <Grid item={true} key="view">
                             <div className="viewButton">
                             <Button
                             style={{marginRight: "60px", float: "right"}}
                               color="primary"
                               variant="contained"
                               component={Link}
                               {...({
                                 to: `/${school.slug}/evaluation/${survey.id}/${sport.id}/${coach.id}`,
                               } as any)}
                             >
                               {VIEW_BUTTON_LABEL}
                             </Button>
                             </div>
                             
                           </Grid>,
                           <Grid item={true} key="print">
                             {showPrintButton && (
                               <Button
                                 onClick={printEvaluation}
                                 color="secondary"
                                 variant="contained"
                               >
                                 {PRINT_BUTTON_LABEL}
                               </Button>
                             )}
                           </Grid>,
                         ];
                       })()}
                     </Grid>
                   );
                 } else {
                   return null;
                 }
               })()}
             </Grid>:
             <Grid container={true} justifyContent="flex-end">
             {(() => {
              const isMidSeason = midSeasonCheckin === true;
              const currentCount = isMidSeason
                ? latestdata[0]?.count[0]
                : count;
          const surveydata =  isMidSeason
          ? latestdata[0] : survey;
              if (isMidSeason && (currentCount === undefined || oldSport !== undefined || !coach.active)) {
                return null;
              }             
              if (
                currentCount?.studentCount +
                currentCount?.coachCount +
                currentCount?.parentCount === 0
              ) {
                 return (
                   <span className={classes.noResponses}>No responses</span>
                 );
               }
               if (
                 surveydata !== undefined 
                 // &&
                 // this.props.showEvaluations(survey)
               ) {
                 // Check if we have summaries for this coach, thats means we show stage 4 buttons
                 return (
                   <Grid
                     container={true}
                     spacing={2}
                     justifyContent="flex-end"
                   >
                     {(() => {
                      // console.log("latestdata[0] view",latestdata[0])
                       if (latestdata[0]?.complete === true) {
                         return (
                           <CheckCircle className={classes.completedCheck} />
                         );
                       }
                       return [
                         <Grid item={true} key="view">
                           <div className="viewButton">
                           <Button
                           style={{marginRight: "60px", float: "right"}}
                             color="primary"
                             variant="contained"
                             component={Link}
                             {...({
                               to: `/${school.slug}/evaluation/${latestdata[0].id}/${sport.id}/${coach.id}`,
                             } as any)}
                           >
                             {VIEW_BUTTON_LABEL}
                           </Button>
                           </div>
                           
                         </Grid>,
                         <Grid item={true} key="print">
                           {showPrintButton && (
                             <Button
                               onClick={printEvaluation}
                               color="secondary"
                               variant="contained"
                             >
                               {PRINT_BUTTON_LABEL}
                             </Button>
                           )}
                         </Grid>,
                       ];
                     })()}
                   </Grid>
                 );
               } else {
                 return null;
               }
             })()}
           </Grid>
      }
            </TableCell>
             {midSeasonCheckin && (
  <TableCell>
    {(() => {
      const coachSurveys = surveys.filter((s) => s.coachId === coach.id);
      // console.log("latestdata[0] buttons", coachSurveys[0])
      if (coachSurveys.length === 0 || coachSurveys[0]?.complete === true) {
        return (
          <Grid item={true}>
          <div className="startEvaluation">
            <Button
              // className={classes.button}
              onClick={this.startEvaluation}
              variant="contained"
              color="primary"
            >
              Start Survey
            </Button>
            {startEvaluationSubmitting && <LinearProgress />}
          </div>

        </Grid>
        );
      }

      // Get latest survey based on responseCollectionEndDate (ignore null values)

      //  coachSurveys.reduce((latest, current) => {
      //   if (current.responseCollectionEndDate === null) {return latest};
      //   return (current.responseCollectionEndDate || 0) > (latest?.responseCollectionEndDate || 0) ? current : latest;
      // }, null as ISurvey | null);  // ✅ Fix: Use 'null' to prevent TS error

      return (
        <>
          {coachSurveys[0]?.responseCollectionEndDate === null 
          ? (
             <Box display="flex">
                              <Box>
                                <div className="stopButton">
                                  <Button
                                    onClick={this.endEvaluation}
                                    variant="contained"
                                  >
                                    Close Survey
                                  </Button>
                                </div>
                                {endEvaluationSubmitting && <LinearProgress />}
                              </Box>
                              <Box>
                                <div style={{marginLeft:"10px"}} className="cancelbutton">
                                  <Button
                                    onClick={() => this.props?.CancelSurvey(coach.id)}
                                    color="secondary"
                                    variant="outlined"
                                  >
                                    Cancel
                                  </Button>
                                </div>
                                {/* {this.props.cancelEvaluationSubmitting && <LinearProgress />} */}
                              </Box>
                            </Box>
          ) : ( coachSurveys[0]?.responseCollectionEndDate !== null
            && coachSurveys[0]?.complete === false
           ) ? (
            <>
            <Grid item={true} key="links">
                            <Box display="flex" alignItems="center" gridGap="1rem">
                              <Grid item={true}>
                                <div className="startNewEvaluation">
                                  <Button
                                   onClick={() => this.props?.StartNewSurvey(coach?.id)}
                                  
                                    variant="contained"
                                    color="primary"
                                  >
                                    Start New Survey
                                  </Button>
                                </div>
                                {/* {this.props?.startNewEvaluationSubmitting && <LinearProgress />} */}
                              </Grid>
                              
                                <Grid item={true}>
                                  <Button
                                    onClick={() => this.props?.ReopenSurvey(coach.id)}
                                    // className={classes.button}
                                    variant="outlined"
                                    color="secondary"
                                  >
                                    Reopen Previous Survey
                                  </Button>
                                 {/* {this.props.continueEvaluationSubmitting && <LinearProgress />} */}
                                </Grid>
                              
                            </Box>
                          </Grid>
            </>
          ) : null}
        </>
      );
    })()}
  </TableCell>
)}

          </TableRow>
        );
      }

      private endEvaluation = () =>
              void this.runCancellableStatefulAsync(
                this,
                {
                  endEvaluationSubmitting: true,
                },
                {
                  endEvaluationSubmitting: false,
                },
                async () => {
                  const { school, sport, coach } = this.props;
                  await this.buildPost<IEvaluationRequest & { coachId: number}, ISurveyResponse>(
                    this,
                    "survey/end"
                  )({
                    schoolId: school.id,
                    sportId: sport.id,
                    coachId: coach?.id
                  });
                  await this.props.loadSurveys(sport.id);
                },
                (ex: any) => {
                  this.setState({ endEvaluationSubmitting: false });
                  console.log("error", ex);
                }
              );
      
private startEvaluation = () =>
        void this.runCancellableStatefulAsync(
          this,
          {
            startEvaluationSubmitting: true,
          },
          {
            startEvaluationModalVisible: false,
            startEvaluationSubmitting: false,
          },
          async () => {
  const res: any = await this.buildGet<IUser>(this, "user")();
    
            const { school, sport,coach, handleSendEvalModalVisible } = this.props;
            const surveyResponse = await this.buildPost<
              IEvaluationRequest & {userId: number, coachId: number},
              ISurveyResponse
            >(
              this,
              "survey/start"
            )({
              schoolId: school.id,
              sportId: sport.id,
              userId: res?.id,
              coachId: coach?.id
            });
            await this.props.loadSurveys(sport.id);
            // open modal with the links
            handleSendEvalModalVisible(surveyResponse);
           
          },
          (ex: any) => {
            this.setState({ startEvaluationSubmitting: false });
            console.log("error", ex);
          }
        );

        private parentOptionValid() {
          // console.log("Object?.keys(this.props.userSubscription).length > 0",Object?.keys(this.props.userSubscription).length > 0)
          let isEnable = true
          if (Object?.keys(this.props.userSubscription).length > 0) {
            // console.log("this.props.userSubscription?.plan?.id===4||this.props.userSubscription?.plan?.id===5",this.props.userSubscription?.plans?.id===4||this.props.userSubscription?.plans?.id===5)
            if(this.props.userSubscription?.plans?.id===4||this.props.userSubscription?.plans?.id===5){
              isEnable = false
            }else if(this.props.addonIDs.includes(2)){
              isEnable = false
            } else{
            isEnable = true
           }
  
          } else {
            isEnable = true
          }
          return isEnable
          // Object?.keys(this.props.userSubscription).length>0?(this.props.userSubscription?.plan?.id!==4&&this.props.userSubscription?.plan?.id!==5)?this.state.addonIDs.includes(2)?false:true:false:false
        }

      private renderPreviousEvaluationsMenu(
        uniqueId: string,
        pastSportSurveys: ISurvey[],
        survey: ISurvey
      ) {
        const { school, sport, coach, menuAnchor } = this.props;
        return (
          <Menu
            id={uniqueId}
            anchorEl={menuAnchor.element}
            open={menuAnchor.id === uniqueId}
            onClose={this.closeMenu}
          >
            {pastSportSurveys.map((s) => (
              <MenuItem
                selected={s === survey}
                key={s.id}
                component={Link}
                {...({
                  to: `/${school.slug}/evaluation/${s.id}/${sport.id}/${coach.id}`,
                } as any)}
              >
                {format(s.startDate, "MMMM D, YYYY")}
              </MenuItem>
            ))}
          </Menu>
        );
      }

      private renderResponseCount() {
        const { loadingResponseCount, classes, count, surveys, midSeasonCheckin, coach } = this.props;
        const survey = surveys[0];
        const latestdata= surveys?.filter((s) => s.coachId === coach.id);
        const midCount = latestdata[0]?.count[0];
        // console.log("midcount", midCount)
        // console.log("mid")
        return (
          <>
          {midSeasonCheckin === false ? 
          <div className={classes.studentCount}>
            {loadingResponseCount ? (
              <LinearProgress />
            ) : (
              <div className="numbers">
                {count && survey !== undefined ? (
                  <span>
                    {" "}
                    {this.props?.schoolData?.isAdSurvey === true ? "Coach" :
                    "Student"}: <b>{count.studentCount}</b>{" "}
                    {survey.type === TemplateType.gritLeadership ? (
                      <>
                        {this.props?.schoolData?.isAdSurvey === true ? "AD" :
                        "Coach" }: <b>{count.coachCount}</b>
                      </>
                    ) : null}{" "}
                    {survey.enableParentQuestions || count.parentCount !== 0 ? (
                      <span>
                        Parent: <b> {count.parentCount} </b>
                      </span>
                    ) : null}
                  </span>
                ) : (
                  <span>...</span>
                )}
              </div>
            )}
          </div>:
          <div className={classes.studentCount}>
            {midCount && latestdata[0] === undefined ? (
              <LinearProgress />
            ) : (
              <div className="numbers">
                {midCount  && latestdata[0] !== undefined ? (
                  <span>
                    {" "}
                    Student: <b>{midCount.studentCount}</b>{" "}
                    {survey.type === TemplateType.gritLeadership ? (
                      <>
                         {this.props?.schoolData?.isAdSurvey === true ? "AD" :
                        "Coach" }: <b>{midCount.coachCount}</b>
                      </>
                    ) : null}{" "}
                    {latestdata[0].enableParentQuestions || midCount.parentCount !== 0 ? (
                      <span>
                        Parent: <b> {midCount.parentCount} </b>
                      </span>
                    ) : null}
                  </span>
                ) : (
                  <span>...</span>
                )}
              </div>
            )}
          </div>
          }
          </>
        );
      }

      private openEditCoach = (e: React.MouseEvent<HTMLElement>) => {
        const { coach } = this.props;
        this.props.openEditCoach(coach);
      };

      private setMenuAnchor = (e: React.MouseEvent<HTMLElement>) => {
        const { sport, coach } = this.props;
        const uniqueId = `${sport.id}${coach.id}`;
        this.props.setMenuAnchor({
          element: e.currentTarget,
          id: uniqueId,
        });
      };

      private closeMenu = () => {
        this.props.setMenuAnchor({
          element: undefined,
          id: "",
        });
      };
    }
  )
);



// WEBPACK FOOTER //
// ./src/pages/director/dashboard/components/sport-table/components/coach-row/CoachRow.tsx